export const defaultContractType = 'Base';
